import { publicConfig } from "@lululemon/ecom-core";
import Cookies from "js-cookie";

export const FM_EVENTS = {
  PAGE_VIEW: "page_view",
  PAGE_LOAD: "page_load_with_fm",
  MODULE_VIEW: "fm_module_view",
  ITEM_CLICK: "item_click",
  NEXT_CLICK: "next_click",
  PREVIOUS_CLICK: "previous_click",
  IMAGE_EXPAND_CLICK: "image_expand_click",
};

export const trackFMEvent = async (interaction, locale, data = {}) => {
  if (typeof document === "undefined") {
    return;
  }

  try {
    const fmAnalyticsHost = publicConfig?.findMineAnalytics?.host;
    const applicationId = publicConfig?.findMineApplicationIds?.[`${locale}`];
    const [language, region] = locale?.split("-") || ["", ""];
    const correlationId =
      Cookies.get("lll-ecom-correlation-id") || crypto.randomUUID();
    const encodedCorrelationId = await getEncodedCorrelationId(correlationId);

    const params = new URLSearchParams({
      application: applicationId,
      interaction: interaction,
      session_id: encodedCorrelationId,
      country: region,
      language: language,
      ...data,
    });
    await fetch(`${fmAnalyticsHost}?${params.toString()}`);
  } catch (err) {
    throw new Error(err);
  }
};

export const getEncodedCorrelationId = async (corrId) => {
  const buffer = new TextEncoder().encode(corrId);
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};
